export default function cleanUrl(url: string) {
  // Remove unnecessary quotes and spaces
  const cleanedUrl = url.replace(/["'\s]/g, '')
  return cleanedUrl
}
